import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceResourceGroupRemoveNotificationState = createStateReducer(
  initialState,
  {
    [events.removeResourceGroupSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeResourceGroup",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.removeResourceGroupFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "removeResourceGroup",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceResourceGroupRemoveNotificationState };
